import { Link } from "react-router-dom";

function ErrorPage() {
  return (
    <section className="bg-zinc-100 dark:bg-gray-900 min-h-screen">
      <div className="mx-auto max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="dark:text-primary-500 mb-4 text-7xl font-extrabold tracking-tight text-blue-600 lg:text-9xl">
            500
          </h1>
          <p className="mb-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl dark:text-white">
            Internal Server Error.
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            Sorry something went wrong.
          </p>
        </div>
        
        <div className="text-center w-full mt-6 gap-x-3 shrink-0 sm:w-auto">
          <Link
            className="w-1/2 px-5 py-2 text-sm tracking-wide text-white transition-colors duration-200 bg-blue-500 rounded-lg shrink-0 sm:w-auto hover:bg-blue-600 dark:hover:bg-blue-500 dark:bg-blue-600 text-nowrap"
            to={"/"}
          >
            Take me home
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ErrorPage;
